package com.neurobs.ccabserver.subjectsessionview.components.sessionrunview.components

import com.neurobs.ccab.TestRunDisplayData
import com.neurobs.ccabserver.subjectsessionview.components.PropertyLabel
import com.neurobs.ccabserver.subjectsessionview.states.UserState
import com.neurobs.js.util.StringUtilities.dateTimeString
import com.neurobs.react.ReactUtil
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

@react
object TestRunView {
  case class Props(testRun: TestRunDisplayData, enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val userState = UserState.accessState
    def isSiteAdmin = userState.userData.isSiteAdmin

    def testRun = props.testRun
    def error = testRun.testRun.runError

    def StartTimeElement: ReactElement = PropertyLabel("Start time", dateTimeString(testRun.testRun.startTime))
    def TestNameElement : ReactElement= testRun.testName.map(testName => PropertyLabel("Test", testName)).getOrElse(null)
    def LogfileElement: ReactElement = if (isSiteAdmin) LogfileLink(testRun.testRun.id) else null
    def ErrorElement: ReactElement = if (error.isDefined) RunErrorMessage(error.get) else null

    props.enclosingElement(
      Seq(
        TestNameElement,
        StartTimeElement,
        ErrorElement,
        LogfileElement
      )
    )

  }
}
